// ──────────────────────────────────────────────
// EVENT CATEGORIES & SUBCATEGORIES
// ──────────────────────────────────────────────

export const EVENT_CATEGORIES = [
  {
    id: "wedding",
    labelKey: "event_wedding",
    label: "Mariage",
    emoji: "💍",
    gradient: "from-rose-300 to-pink-500",
    bg: "bg-rose-100",
    text: "text-rose-600",
    cover: "https://images.unsplash.com/photo-1519741497674-611481863552?w=800&q=85",
    subcategories: [
      { id: "wedding_ceremony", labelKey: "sub_wedding_ceremony", label: "Mariage", emoji: "💍" },
      { id: "engagement",       labelKey: "sub_engagement",       label: "Fiançailles", emoji: "💎" },
      { id: "proposal",         labelKey: "sub_proposal",         label: "Demande en mariage", emoji: "💐" },
      { id: "vow_renewal",      labelKey: "sub_vow_renewal",      label: "Renouvellement de vœux", emoji: "🕊️" },
      { id: "bachelor",         labelKey: "sub_bachelor",         label: "EVJF / EVG", emoji: "🎊" },
    ],
    defaultOptions: ["gift_fund", "archive", "co_host"],
    shareMessage: "Scannez pour partager les souvenirs de notre mariage 💍",
    themeColor: "champagne",
  },
  {
    id: "birthday",
    labelKey: "event_birthday",
    label: "Anniversaire",
    emoji: "🎂",
    gradient: "from-amber-400 to-orange-500",
    bg: "bg-amber-100",
    text: "text-amber-600",
    cover: "https://images.unsplash.com/photo-1464349153735-7db50ed83c84?w=800&q=85",
    subcategories: [
      { id: "birthday_adult",   labelKey: "sub_birthday_adult",   label: "Anniversaire adulte", emoji: "🎂" },
      { id: "birthday_child",   labelKey: "sub_birthday_child",   label: "Anniversaire enfant", emoji: "🎈" },
      { id: "birthday_surprise",labelKey: "sub_birthday_surprise",label: "Fête surprise", emoji: "🎁" },
      { id: "birthday_big",     labelKey: "sub_birthday_big",     label: "Anniversaire marquant", emoji: "✨" },
    ],
    defaultOptions: ["gift_fund", "archive"],
    shareMessage: "Ajoutez vos photos de la fête ! 🎉",
    themeColor: "amber",
  },
  {
    id: "family",
    labelKey: "event_family",
    label: "Famille",
    emoji: "👨‍👩‍👧‍👦",
    gradient: "from-emerald-400 to-teal-500",
    bg: "bg-emerald-100",
    text: "text-emerald-600",
    cover: "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=800&q=85",
    subcategories: [
      { id: "family_reunion",    labelKey: "sub_family_reunion",    label: "Réunion de famille", emoji: "👨‍👩‍👧‍👦" },
      { id: "housewarming",      labelKey: "sub_housewarming",      label: "Pendaison de crémaillère", emoji: "🏡" },
      { id: "family_celebration",labelKey: "sub_family_celebration",label: "Célébration familiale", emoji: "🎊" },
      { id: "anniversary",       labelKey: "sub_anniversary",       label: "Anniversaire de mariage", emoji: "💑" },
    ],
    defaultOptions: ["archive", "co_host"],
    shareMessage: "Partagez vos souvenirs de famille 📸",
    themeColor: "emerald",
  },
  {
    id: "baby_shower",
    labelKey: "event_baby_shower",
    label: "Naissance & Enfants",
    emoji: "👶",
    gradient: "from-sky-300 to-blue-400",
    bg: "bg-sky-100",
    text: "text-sky-600",
    cover: "https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?w=800&q=85",
    subcategories: [
      { id: "baby_shower_event", labelKey: "sub_baby_shower",      label: "Baby shower", emoji: "🍼" },
      { id: "gender_reveal",     labelKey: "sub_gender_reveal",    label: "Gender reveal", emoji: "🎀" },
      { id: "birth",             labelKey: "sub_birth",            label: "Naissance", emoji: "👶" },
      { id: "baptism",           labelKey: "sub_baptism",          label: "Baptême", emoji: "🕊️" },
      { id: "kids_party",        labelKey: "sub_kids_party",       label: "Fête d'enfant", emoji: "🎈" },
    ],
    defaultOptions: ["gift_fund", "archive"],
    shareMessage: "Partagez ce moment magique avec nous 🍼",
    themeColor: "sky",
  },
  {
    id: "graduation",
    labelKey: "event_graduation",
    label: "Études & Jeunesse",
    emoji: "🎓",
    gradient: "from-violet-400 to-purple-600",
    bg: "bg-violet-100",
    text: "text-violet-600",
    cover: "https://images.unsplash.com/photo-1627556704302-624286467c65?w=800&q=85",
    subcategories: [
      { id: "graduation_event",  labelKey: "sub_graduation",       label: "Graduation", emoji: "🎓" },
      { id: "diploma",           labelKey: "sub_diploma",          label: "Remise de diplôme", emoji: "📜" },
      { id: "prom",              labelKey: "sub_prom",             label: "Bal de finissants", emoji: "🌟" },
      { id: "student_gala",      labelKey: "sub_student_gala",     label: "Gala étudiant", emoji: "🥂" },
    ],
    defaultOptions: ["archive", "gift_fund"],
    shareMessage: "Célébrons ensemble cette réussite ! 🎓",
    themeColor: "violet",
  },
  {
    id: "corporate",
    labelKey: "event_corporate",
    label: "Professionnel",
    emoji: "🏢",
    gradient: "from-slate-400 to-gray-600",
    bg: "bg-slate-100",
    text: "text-slate-600",
    cover: "https://images.unsplash.com/photo-1556761175-4b46a572b786?w=800&q=85",
    subcategories: [
      { id: "corporate_event",   labelKey: "sub_corporate",        label: "Événement d'entreprise", emoji: "🏢" },
      { id: "team_building",     labelKey: "sub_team_building",    label: "Team building", emoji: "🤝" },
      { id: "product_launch",    labelKey: "sub_product_launch",   label: "Lancement de produit", emoji: "🚀" },
      { id: "conference",        labelKey: "sub_conference",       label: "Conférence", emoji: "🎤" },
      { id: "networking",        labelKey: "sub_networking",       label: "Networking", emoji: "💼" },
    ],
    defaultOptions: ["gift_fund", "co_host"],
    shareMessage: "Join the private event gallery 📸",
    themeColor: "slate",
  },
  {
    id: "private_party",
    labelKey: "event_private_party",
    label: "Soirée & Social",
    emoji: "🎉",
    gradient: "from-fuchsia-500 to-purple-600",
    bg: "bg-fuchsia-100",
    text: "text-fuchsia-600",
    cover: "https://images.unsplash.com/photo-1543269865-cbf427effbad?w=800&q=85",
    subcategories: [
      { id: "private_party_event",labelKey: "sub_private_party",  label: "Soirée privée", emoji: "🎉" },
      { id: "bbq",               labelKey: "sub_bbq",             label: "BBQ", emoji: "🍖" },
      { id: "brunch",            labelKey: "sub_brunch",          label: "Brunch", emoji: "🥞" },
      { id: "pool_party",        labelKey: "sub_pool_party",      label: "Pool party", emoji: "🏊" },
      { id: "new_year",          labelKey: "sub_new_year",        label: "Nouvel An", emoji: "🎆" },
      { id: "halloween",         labelKey: "sub_halloween",       label: "Halloween", emoji: "🎃" },
    ],
    defaultOptions: ["gift_fund", "archive"],
    shareMessage: "Partagez vos photos de la soirée ! 🎉",
    themeColor: "fuchsia",
  },
  {
    id: "other",
    labelKey: "event_other",
    label: "Autre",
    emoji: "📅",
    gradient: "from-gray-400 to-gray-500",
    bg: "bg-gray-100",
    text: "text-gray-600",
    cover: "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=800&q=85",
    subcategories: [
      { id: "custom",            labelKey: "sub_custom",          label: "Événement personnalisé", emoji: "📅" },
      { id: "community",         labelKey: "sub_community",       label: "Communautaire / religieux", emoji: "🕊️" },
      { id: "group_travel",      labelKey: "sub_group_travel",    label: "Voyage de groupe", emoji: "✈️" },
      { id: "sport_culture",     labelKey: "sub_sport_culture",   label: "Sport / culture", emoji: "🎭" },
    ],
    defaultOptions: ["archive"],
    shareMessage: "Partagez vos photos de l'événement 📸",
    themeColor: "gray",
  },
];

// Legacy EVENT_TYPES — maps to categories for backward compatibility
export const EVENT_TYPES = EVENT_CATEGORIES;

export const getEventType = (id) => {
  // Check by category id
  const cat = EVENT_CATEGORIES.find(c => c.id === id);
  if (cat) return cat;
  // Check by subcategory id — return parent category
  for (const c of EVENT_CATEGORIES) {
    if (c.subcategories?.find(s => s.id === id)) return c;
  }
  return EVENT_CATEGORIES[EVENT_CATEGORIES.length - 1];
};

export const getSubcategory = (subcatId) => {
  for (const c of EVENT_CATEGORIES) {
    const sub = c.subcategories?.find(s => s.id === subcatId);
    if (sub) return sub;
  }
  return null;
};

export const REACTION_TYPES = [
  { type: "heart",   emoji: "❤️", labelKey: "reaction_heart",   field: "heart_count"   },
  { type: "funny",   emoji: "😂", labelKey: "reaction_funny",   field: "funny_count"   },
  { type: "shocked", emoji: "😮", labelKey: "reaction_shocked", field: "shocked_count" },
];

export function generateAccessCode() {
  const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
  let code = "";
  for (let i = 0; i < 6; i++) code += chars[Math.floor(Math.random() * chars.length)];
  return code;
}
